/**
 * Publishes the deploy identity into the document so we can confirm
 * which git SHA is live on pre-prod / prod (see scripts/wait-for-deploy.mjs).
 */
const sha = import.meta.env.VITE_GIT_SHA || 'local';
const ref = import.meta.env.VITE_GIT_REF || 'local';

declare global {
  interface Window {
    __CALENDARIFY_BUILD__?: { sha: string; ref: string };
  }
}

window.__CALENDARIFY_BUILD__ = { sha, ref };

let meta = document.querySelector('meta[name="x-calendarify-build"]') as HTMLMetaElement | null;
if (!meta) {
  meta = document.createElement('meta');
  meta.name = 'x-calendarify-build';
  document.head.appendChild(meta);
}
meta.content = `${ref}@${sha}`;
